import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import styles from './FloatingAgentCard.scss';
import _debounce from 'lodash/debounce';
import agentURL from '../../lib/urlWriters/agentURL';
import {dataLayerPush, trackBeginCheckout, trackContactAgent} from '../../lib/tracking';
import Linkify from '../Linkify/Linkify';
import AgentAvatar from '../AgentAvatar/AgentAvatar';
import {breakpointLgLow} from '../../lib/config';
import {getRmaHeadshot} from '../../lib/rmaUtils';
import {getAuctionSaleType} from '../../selectors/openn';

function FloatingAgentCard(props) {
  const isSmallerDevice = () => (typeof window != 'undefined' && window?.innerWidth < breakpointLgLow);
  const propertyDetail = useSelector(state => state.propertyDetail);
  const user = useSelector(state => state.user);
  const opennAuction = useSelector(state => state.opennAuction);
  const [showing, setShowing] = useState(false);

  const rmaAgentProfiles = useSelector(state => state.rmaAgentProfiles);

  const testScrollPos = () => {
    // yikes
    let contactForm = document.getElementById("listing-enquiry-form");
    let agentCard = document.getElementById("listing-agent-card");
    if (contactForm && agentCard) {
      let newShowing = false;
      let contactTop = contactForm.getBoundingClientRect().top;
      let cardRect = agentCard.getBoundingClientRect();
      if ((contactTop > window.innerHeight) && (cardRect.top < (0 - cardRect.height))) newShowing = true;
      setShowing(newShowing);
      if (props?.showingFunc) props.showingFunc(newShowing);
    }
  }
  const debounceScroll = _debounce(testScrollPos, 150);

  useEffect(() => { // mount
    // dom stuff
    window.addEventListener('scroll', debounceScroll);
    return () => { // unmount
      window.removeEventListener('scroll', debounceScroll);
    }
  }, []);

  const scrollToForm = (event) => {
    event.preventDefault();
    if (window != 'undefined') {
      let form = document.getElementById('listing-enquiry-form');
      let rect = form.getBoundingClientRect();
      let top = Math.floor(window.scrollY + rect.top);
      window.scrollTo(0, top);
    }
  }

  const getAgencyId = (property) => {
    if (property.category === 'Property' && property.recentlySold) {
      return property.lastSale.sellingAgency.agencyId;
    }
    return property.listing.agency.agencyId;
  };

  const trackClick = (eventName) => {
    dataLayerPush({event: eventName});
    if (propertyDetail && propertyDetail.status === 'success') {
      const {property} = propertyDetail;
      trackContactAgent(user?.currentUser?.preferences?.CONSUMER_TYPE, user?.currentUser?.preferences?.FINANCE_POSITION,
        getAgencyId(property), 'Call', property, props.agency?.agents?.[0]?.uuid, props.agency?.agents, propertyDetail);
      trackBeginCheckout(property, getAgencyId(property), props.agency?.agents?.[0]?.uuid, property.id, getAuctionSaleType(opennAuction));
    }
  };

  const getAgentUrl = (agent) => {
    const hasESDetails = !props.isRecentSold || props.agency?.agencyId;
    if (agent.contact && (agent.contact.phone || agent.contact.email)) {
      return hasESDetails && agentURL(agent, props.agency);
    }
  };

  const getAgentClickableName = (agent) => {
    return agent && <Linkify
      content={agent.name}
      url={getAgentUrl(agent)}
      containerClass={'bold600 ' + styles.agentName}
    />;
  };

  const getMultipleAgentNames = (agentList) => {
    return <div className={'d-flex'}>
      {getAgentClickableName(agentList[0])} <span className={styles.ampersand}>&nbsp;&&nbsp;</span> {getAgentClickableName(agentList[1])}
    </div>;
  };

  const getAgentContactInfo = (agent) => {
    return agent.contact?.phone?.mobile || agent.contact?.phone?.business || props.agency.phoneNumber;
  };

  const getAgentView = (agentList) => {
    const agentHeadShot = agentList[0].headShot ? agentList[0].headShot : getRmaHeadshot(rmaAgentProfiles, agentList[0].uuid, '/assets/images/profile_icon.svg');

    return (
      <div className={'d-flex align-items-center ' + styles.agentProfile}>
        {agentList?.length === 1 ? <Linkify
          content={<AgentAvatar size={isSmallerDevice() ? '' : 'xl'} avatarUrl={agentHeadShot} />}
          url={getAgentUrl(agentList[0])}
        /> : null}

        <div className="flex-grow-1 ml-2 ml-lg-3">
          {agentList?.length > 1 ? getMultipleAgentNames(agentList) : getAgentClickableName(agentList.find(agent => agent.name))}
          <Linkify
            content={props.agency.name || 'Agency name not disclosed'}
            url={agentList[0].agentURL}
            containerClass={styles.agencyName}
          />
        </div>
      </div>
    );
  };

  return (
    showing && props.agency?.agents && props.agency?.agents.length > 0 ?
      <div className={"position-fixed d-flex justify-content-center " + styles.cardWrapper}>
        <div className={styles.floatingAgentCard}>
          {getAgentView(props.agency.agents)}
          <div className={"d-flex align-items-center " + styles.contactButtons}>
            <div className="d-flex justify-content-end text-center w-100">
              {getAgentContactInfo(props.agency.agents[0]) ? <a onClick={() => trackClick('clickToContact-FloatingBar-callClicked')} href={'tel:' + getAgentContactInfo(props.agency.agents[0])} className="odinButton mr-2 w-50">Call</a> : null}
              <a onClick={(event) => {trackClick('clickToContact-FloatingBar-emailClicked'); scrollToForm(event)}} href="#listing-enquiry-form" className="odinButton ml-2 w-50">Message</a>
            </div>
          </div>
        </div>
      </div>
      : null
  );
}

FloatingAgentCard.propTypes = {
  agency: PropTypes.object.isRequired,
  isRecentSold: PropTypes.bool,
};

export default FloatingAgentCard;
